import React, { useEffect, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import {
    BrowserRouter as Router, Route, Switch, useRouteMatch
} from "react-router-dom";
import { db } from "../../../firebase";

import ExportCSVSeason from "./export_csv_season";


export default function ExportCSV() {
    var [allSeasons, setallSeasons] = useState([])

    let match = useRouteMatch()

    function getAllSeasons() {
        db.collection("seasons").get()
            .then((querySnapshot) => {
                var allSeasonsList = []
                querySnapshot.forEach((doc) => {
                    var seasonObj = doc.data()
                    seasonObj.id = doc.id
                    allSeasonsList.push(seasonObj)
                })
                // console.log(allSeasonsList)

                setallSeasons(allSeasonsList)
            })
            .catch((e) => {
                console.log(e)
            })
    }


    useEffect(() => {
        getAllSeasons()
    }, [])


    let tabs = (
        allSeasons.map((doc, ind) =>
            <LinkContainer to={`${match.url}/${doc.id}`} key={ind}>
                <Nav.Link>
                    <b>{doc.seasonName}</b>
                </Nav.Link>
            </LinkContainer>
        )
    )

    let seasons = (
        <div id="seasons-container">
            <Navbar
                variant="dark"
                className="seasons-navbar"
            >

                <Navbar.Collapse>
                    <Nav className="flex-row"
                        navbarScroll>
                        <LinkContainer to={`${match.url}/`}>
                            <Nav.Link>
                                <b>Seasons</b>
                            </Nav.Link>
                        </LinkContainer>
                        {tabs}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>

        </div>
    )

    return (
        <div>
            <Router>
                <div>
                    {seasons}
                </div>
                <Switch>
                    <Route path={`${match.url}/:id`}>
                        <ExportCSVSeason />
                    </Route>
                </Switch>
            </Router>
        </div>
    )
}